import Storage from './modules/Storage'
import suits from './suits.svg'
import ZZFX from './ZzFX'

export const SUITS_IMAGE: HTMLImageElement = new Image()
SUITS_IMAGE.src = suits

export const suitsImagePromise: Promise<HTMLImageElement> = new Promise(resolve => {
    if (SUITS_IMAGE.complete) {
        resolve(SUITS_IMAGE)
    } else {
        SUITS_IMAGE.onload = () => resolve(SUITS_IMAGE)
    }
})

export const YANDEX_METRIKA_ID: number = 57089248

export const STAT_STORAGE_KEY: string = 'durak-stat'

export const DESC_MAX_WIDTH: number = 600

const env = process.env

export const DEV_MODE: boolean = env.NODE_ENV && env.NODE_ENV === 'development'

export const FAST_MODE: boolean = window.location.search === '?fast' && DEV_MODE

export const appStorage = new Storage(STAT_STORAGE_KEY, {
    // stat
    win: 0,
    loss: 0,
    draw: 0,
    series: 0,
    maxSeries: 0,
    // buttons
    mute: false,
    hideBaldaCards: false,
    // other
    catFound: false,
})

export interface Settings {
    difficulty: string
    saveLogs: boolean
    minLogLength: number
    advtInterval: number
    advtLimit: number
    advtDesktopDisable: boolean
    advtOnComplete: boolean
    advtOnEndBattle: boolean
    advtOnCloseConfirm: boolean
    lastShowAdvertTimeInitial: number
}

export const SECOND: number = 1000
export const MINUTE: number = 60 * SECOND

export const DEFAULT_SETTINGS: Settings = {
    difficulty: 'auto',
    saveLogs: false,
    minLogLength: 10,
    advtInterval: 3.5,
    advtLimit: 15,
    advtDesktopDisable: false,
    advtOnComplete: true,
    advtOnEndBattle: true,
    advtOnCloseConfirm: true,
    lastShowAdvertTimeInitial: 3 * MINUTE,
}

export const getSettings = async (): Promise<Settings> => {
    let settings = {}
    return Object.assign({}, DEFAULT_SETTINGS, settings)
}

// Звуки

let muted: boolean = false

export const globalMuteSound = (timeout: number = 3000): void => {
    muted = true
    setTimeout(() => (muted = false), timeout)
}

const playSound = (seed: number, volume: number = 0.2): void => {
    if (!muted) {
        new ZZFX().z(seed, {volume})
    }
}

export const playClickSound = (): void => playSound(40846)

export const playSlideSoundEffect = (): void => playSound(80833, 0.1)

export const playCardSoundEffect = (): void => playSound(63020)
